import React from 'react';
import IconCompare from '@assets/Icon/svg/IconCompare';
import { N700, primary } from '@assets/colors';
import { bool, func } from 'prop-types';
import { noop } from '@ajaibid/utils';
import ButtonV2 from '../Ajaib/ButtonV2';
import { styCompareBtn } from './style';

export default function ButtonCompare({ isCompareModeActive, onClick }) {
  return (
    <ButtonV2
      variant="grey-outlined"
      size="sm"
      iconPosition="left"
      icon={(
        <IconCompare
          style={{ marginRight: 'auto' }}
          color={isCompareModeActive ? primary : N700}
        />
      )}
      className={styCompareBtn(isCompareModeActive)}
      onClick={() => onClick()}
      style={{
        outlineColor: `${isCompareModeActive ? primary : N700} !important`,
      }}
    >
      Bandingkan
    </ButtonV2>
  );
}

ButtonCompare.propTypes = {
  isCompareModeActive: bool,
  onClick: func,
};

ButtonCompare.defaultProps = {
  isCompareModeActive: false,
  onClick: noop,
};
